import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    COUNTS,
    COUNTS_SUCCESS,
    COUNTS_FAIL,
    GET_RECENT_QUOTES,
    GET_RECENT_QUOTES_SUCCESS,
    GET_RECENT_QUOTES_FAIL,
    GET_PIE_CHART,
    GET_PIE_CHART_FAIL,
    GET_PIE_CHART_SUCCESS,
    GET_BAR_CHART,
    GET_BAR_CHART_SUCCESS,
    GET_BAR_CHART_FAIL,
} from "./actionTypes";

export const apiSuccess = (actionType, data) => ({
    type: API_SUCCESS,
    payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
    type: API_FAIL,
    payload: { actionType, error },
});

// charts data
export const getChartsData = (periodType) => ({
    type: GET_CHARTS_DATA,
    payload: periodType
});

// user count data
export const getCounts = () => ({
    type: COUNTS,
})
export const getCountsSuccess = Counts => ({
    type: COUNTS_SUCCESS,
    payload: Counts,
})
export const getCountsFail = error => ({
    type: COUNTS_FAIL,
    payload: error,
})

// recent quotes 
export const getRecentQuotes = () => ({
    type: GET_RECENT_QUOTES
})
export const getRecentQuotesSuccess = recentQuotes => ({
    type: GET_RECENT_QUOTES_SUCCESS,
    payload: recentQuotes,
})
export const getRecentQuotesFail = error => ({
    type: GET_RECENT_QUOTES_FAIL,
    payload: error,
})

//pie chart
export const getPieChartData = () => ({
    type: GET_PIE_CHART
})
export const getPieChartDataSuccess = pieChart => ({
    type: GET_PIE_CHART_SUCCESS,
    payload: pieChart,
})
export const getPieChartDataFail = error => ({
    type: GET_PIE_CHART_FAIL,
    payload: error,
})

//bar chart
export const getBarChartData = () => ({
    type: GET_BAR_CHART
})
export const getBarChartDataSuccess = barChart => ({
    type: GET_BAR_CHART_SUCCESS,
    payload: barChart,
})
export const getBarChartDataFail = error => ({
    type: GET_BAR_CHART_FAIL,
    payload: error,
})